import { SET_BLOG_TO_EDIT, SET_NEWS, SET_NEWS_TO_EDIT } from '../constants'

const initialState = {
	allNews: [],
	newsToEdit: false,
	blogToEdit: false,
}

export function news(state = initialState, action) {
	const newState = { ...state }
	switch (action.type) {
		case SET_NEWS:
			newState.allNews = action.news
			return newState

		case SET_NEWS_TO_EDIT:
			newState.newsToEdit = action.news
			return newState
		case SET_BLOG_TO_EDIT:
			newState.blogToEdit = action.news
			return newState
		default:
			return state
	}
}
